import { styled } from "@mui/material";

/**
 * Holds the button for closing the drawer, as well as buttons for additional actions, such as loggin out.
 */
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default DrawerHeader;
